import * as React from 'react';
const AppContext = React.createContext({
    modalRoot: null,
    popoverRoot: null,
});
export default AppContext;
//# sourceMappingURL=AppContext.js.map